import {UserDataApi} from "../api/UserDataApi";
import {useUserState} from "../store/user-store";


export namespace UserService {
    export const getCurrentUser = async () => {
        const userRes = await UserDataApi.getCurrentUser();
        if(!userRes.data) {
            console.error("Failed to get current user");
            return undefined;
        } else {
            return userRes.data;
        }
    }

    export const initCurrentUser = () => {
        getCurrentUser().then((user) => {
            console.log("Current user info loaded!")
            useUserState.getState().setCurrentUser(user);
        })
    }
}